import fetch from '@/utils/fetch'

export const List = '/members/guarantee/list'

export function handleExport (query) {
  return fetch({
    url: List,
    method: 'get',
    params: query
  })
}
